import PropTypes from 'prop-types';

export default function OutlineScan(props) {
    const { color = 'currentColor', size = 20, strokeWidth = 1.5, ...rest } = props;

    return (
        <svg viewBox="0 0 20 20" fill="none" width={size} height={size} {...rest}>
            <path
                d="M3 13.5v3.2a1.8 1.8 0 0 0 1.8 1.8h8.7C15 18.5 15 17 15 17v-3.5M3 9V3.3a1.8 1.8 0 0 1 1.8-1.8H12l1.35 1.35"
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={strokeWidth}
            />
            <path
                d="M9.5 5h-2a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1Z"
                stroke={color}
                strokeWidth={strokeWidth}
            />
            <path
                d="M16 11.2H2M10.5 15.2H6.6"
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={strokeWidth}
            />
            <path
                d="M16.207 7.672 16 8.5l-.207-.828a2.7 2.7 0 0 0-1.964-1.965L13 5.5l.829-.207a2.7 2.7 0 0 0 1.964-1.965L16 2.5l.207.828a2.7 2.7 0 0 0 1.965 1.965L19 5.5l-.828.207a2.7 2.7 0 0 0-1.965 1.965Z"
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={strokeWidth}
            />
        </svg>
    );
}

OutlineScan.propTypes = {
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string,
    strokeWidth: PropTypes.number,
};
